import React from 'react'
import Link from 'next/link'
import * as S from './UpperBlocks.styled'
import { useOpenStockSelectorWithBasketItems } from 'src/features/shipment-selector/hooks'
import { useIsBasketModalErecipe, useToggleBasketModalErecipe } from '@entities/prescription/hooks'

const UpperBlocks = (props) => {
    const openStockSelectorWithBasketItems = useOpenStockSelectorWithBasketItems()
    const toggleBasketModalErecipe = useToggleBasketModalErecipe()
    const isBasketModalErecipe = useIsBasketModalErecipe()
    return (
        <S.Container>
            <S.Block data-erecipe-show onClick={() => toggleBasketModalErecipe(false)}>
                <S.IconContainer>
                    <S.Icon src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/prescription.svg`} />
                </S.IconContainer>
                <S.Description>
                    <S.SpanDescription>Электронный рецепт</S.SpanDescription>
                </S.Description>
            </S.Block>
            <S.Block data-stocks-show onClick={openStockSelectorWithBasketItems}>
                <S.IconContainer>
                    <S.Icon src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/room.svg`} />
                </S.IconContainer>
                <S.Description>
                    <S.SpanDescription>Адреса аптек </S.SpanDescription>
                </S.Description>
            </S.Block>
            <Link href="/catalog/promotion/list" passHref legacyBehavior>
                <S.Block>
                    <S.IconContainer>
                        <S.Icon src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/sale-mobile.svg`} />
                    </S.IconContainer>
                    <S.Description>
                        <S.SpanDescription>Скидки и акции</S.SpanDescription>
                    </S.Description>
                </S.Block>
            </Link>
        </S.Container>
    )
}

UpperBlocks.propTypes = {}

export default UpperBlocks
